module.exports = __webpack_public_path__ + "img/3_uk.4e875b86.svg";